import { render, staticRenderFns } from "./JoinedCompaignCard.vue?vue&type=template&id=fc3f1c94&scoped=true"
import script from "./JoinedCompaignCard.vue?vue&type=script&lang=js"
export * from "./JoinedCompaignCard.vue?vue&type=script&lang=js"
import style0 from "./JoinedCompaignCard.vue?vue&type=style&index=0&id=fc3f1c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f1c94",
  null
  
)

export default component.exports